import { useState } from "react";
import { Send, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { subscribeNewsletter } from "@/lib/api";

export default function NewsletterForm({ variant = "footer" }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await subscribeNewsletter(email, variant);
      toast.success("You're subscribed. Welcome to Groman Insights.");
      setEmail("");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(detail || "Subscription failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const isFooter = variant === "footer";

  return (
    <form onSubmit={onSubmit} data-testid={`newsletter-form-${variant}`} className="flex gap-0">
      <input
        type="email"
        required
        placeholder="you@company.com"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        data-testid={`newsletter-input-${variant}`}
        className={`flex-1 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-gold ${
          isFooter
            ? "bg-white/5 border border-white/15 text-white placeholder:text-white/40"
            : "bg-white border border-gray-200 text-charcoal placeholder:text-charcoal-soft/50"
        }`}
      />
      <button
        type="submit"
        disabled={loading}
        data-testid={`newsletter-submit-${variant}`}
        className="inline-flex items-center gap-2 bg-gold text-white px-5 py-3 text-sm font-medium hover:bg-gold-hover transition-colors disabled:opacity-60"
      >
        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
        Subscribe
      </button>
    </form>
  );
}
